import React from "react";
import { useDispatch, useSelector } from "react-redux";
import useSetStep from "../../../hooks/ReportBuilderTargets/useSetStep";
import { filterSelectionsToDisabled, getModuleCode, renderTargetSelectionItems } from "../../../utils/oneintelligence/OneIntelligenceHelper";
import MarketExplorerContainer from "./MarketExplorerContainer";
import TargetItemGroup from "./TargetItemGroup";
import { setConfigSelectedTarget, setStep, setToEditData } from "../../../store/components/MarketExplorer.slice";

const TargetView = function () {
    const dispatch = useDispatch();
    const {
        configuration: {
            buildedTargets
        }
    } = useSelector((state) => state.marketExplorer);
    useSetStep();

    const behaviorList = filterSelectionsToDisabled();
    const moduleCode = getModuleCode();
    const onClick = (item) => {
        const [parent] = buildedTargets
        const [group] = parent.groups

        dispatch(setToEditData({
            mode: "and",
            data: {
                ...group,
                audienceId: parent.key,
                groupIndex: 0
            }
        }));
        dispatch(setConfigSelectedTarget(item));
        dispatch(setStep(2));
    }
    const newList = (buildedTargets.length ? [behaviorList[0]] : behaviorList).filter((i) => i);
    return (
        <MarketExplorerContainer className="reportBuilder-leftside_targets-view">
            {buildedTargets.map((item) => (
                <div key={item.key}>
                    <TargetItemGroup key={item.key} data={item} />
                </div>
            ))}

            {newList.reduce((acc, item, idx) => {
                if (!idx) {
                    if (["healthcarewhitespaces", "veterinaryjourney"].includes(moduleCode)) {
                        acc.push(<span className="c-bg-400 or-el">Next: Select the endpoints for the analysis.</span>);
                    } else if (moduleCode === "whitespacesmodule") {
                        acc.push(<span className="c-bg-400 or-el">Next: Select the endpoints for the analysis.</span>);
                    } else acc.push(<span className="c-bg-400 or-el">{!item?.dontDisplayType ? item?.typeToDiplay : ""}</span>);
                }
                acc.push(renderTargetSelectionItems(item, onClick, {
                    isFirst: true,
                    isDisabled: true
                }, ["healthcarewhitespaces", "veterinaryjourney", "whitespacesmodule"].includes(moduleCode) ? false : true));
                if (newList.length - 1 !== idx) {
                    if (item?.typeToDiplay) {
                        acc.push(<span className="c-bg-400 or-el">{!item?.dontDisplayType ? item?.typeToDiplay : ""}</span>);
                    }
                }
                return acc;
            }, [])}
        </MarketExplorerContainer>
    );
};

export default TargetView;
